import { PublicRoutes } from "@/constants/routes";
import { TOOLS } from "@/pages/ferramentas/constants";
import { NavMenu } from "./navMenu";

const items = TOOLS.map(tool => ({
  key: tool.key,
  title: tool.name,
  description: tool.summary,
  to: tool.path,
}));

export const ToolsMenu = () => (
  <NavMenu
    label="Ferramentas"
    items={items}
    footerText="Grátis e sem cadastro, para quem vende no crediário."
    footerCta={{
      label: "Ver todas as ferramentas",
      to: PublicRoutes.FERRAMENTAS,
    }}
  />
);
